import React from 'react';
import cn from 'classnames';

import { TouristsPicker } from '@lt/components';
import { useTranslation } from '@lt/localization';
import { pluralizeYears } from '../../../../../../utils/pluralizeUtils';

import SearchParamsLabel from '../SearchParamsLabel';
import SearchParamsControl from '../SearchParamsControl';

import styles from './searchParamsTourists.module.css';

interface SearchParamsTouristsProps {
  adults: number;
  kids?: number[];
  isMobile?: boolean;
  onChangeAdults: (value: number) => void;
  onChangeKids: (kidValue: number[]) => void;
  hasAdjustParams?: boolean;
  isHotelOnly: boolean;
  isArchived: boolean;
}

const SearchParamsTourists = ({
  adults,
  kids = [],
  isMobile,
  onChangeAdults,
  onChangeKids,
  hasAdjustParams,
  isHotelOnly,
  isArchived,
}: SearchParamsTouristsProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      <div className={styles.tourists}>
        <div className={styles.tourist}>
          <div
            className={cn(styles.number, { [styles.mobileNumber]: isMobile })}
          >
            {adults}
          </div>
          <div className={styles.type}>
            {t('checkout.tourists.search.adult')}
          </div>
        </div>
        {kids.length !== 0 && (
          <>
            <div
              className={cn(styles.number, { [styles.mobileNumber]: isMobile })}
            >
              +
            </div>
            <div
              className={cn(styles.tourist, styles.kid, {
                [styles.mobileKid]: isMobile,
              })}
            >
              <div
                className={cn(styles.number, {
                  [styles.mobileNumber]: isMobile,
                })}
              >
                {kids.length}
              </div>
              <div className={styles.type}>
                {t('checkout.search.kids')}
                {!hasAdjustParams && !isMobile && (
                  <span>
                    {': '}
                    {kids
                      .map((age) => `${age} ${pluralizeYears(age)}`)
                      .join(', ')}
                  </span>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {!isArchived && !isHotelOnly && (
        <TouristsPicker
          adultsValue={adults}
          kidsValue={kids}
          onChangeAdults={onChangeAdults}
          onChangeKids={onChangeKids}
          isMobile={isMobile}
          CustomControl={SearchParamsControl}
          CustomLabel={SearchParamsLabel}
          isHotelOnly
        />
      )}
    </div>
  );
};

export default SearchParamsTourists;
